import { http } from "../api/http";
import Utils from "../utils";

export const dashboardService = {
  get,
};

function get(requestParameters) {
  let url = `/dashboard?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}
